import * as React from 'react';

export const AmenityTitle = ({ category, title }) => {
  if (!title) {
    return null;
  }

  return <h4 className={`policies__header--secondary uitk-type-heading-500 uitk-type-bold info-${category}__section__title`}>{title}</h4>;
};
